import { html, render } from "lit-html";
import { Input } from "./input";

class HelpDialog {
  constructor() {
    this.overlay = document.querySelector(".overlay");
    this.dialog = document.querySelector(".dialog");
  }

  handleInput(key) {
    switch (key) {
      case "q":
      case "Enter":
      case " ":
        document.dispatchEvent(new CustomEvent("ui.transition", {
          detail: {
            command: "CloseDialog",
          }
        }));
      break;
    }
    return false;
  }

  rescale() {
    return;
  }

  activate(context) {
    this.overlay.classList.add("is-visible");
    this.dialog.classList.add("is-visible");
    render(this.getDialogTemplate(), this.dialog);
  }

  deactivate(context) {
    this.overlay.classList.remove("is-visible");
    this.dialog.classList.remove("is-visible");
  }

  getDialogTemplate() {
    return html`
      <h2>Help</h2>
      <p><kbd>←→↑↓</kbd> or <kbd>hjkl</kbd> to move. Bump into tiles and creatures to interact and attack.</p>
      <p><kbd>z</kbd> or <kbd>?</kbd> to look around. <kbd>t</kbd> or <kbd>f</kbd> to target a ranged weapon.</p>
      <p><kbd>.</kbd> or <kbd>r</kbd> to rest. <kbd>g</kbd> and <kbd>d</kbd> to pick up and drop items</p>
      <p><kbd>e</kbd> or <kbd>i</kbd> to open the equipment dialog. Use <kbd>←→↑↓</kbd> keys to navigate and <kbd>Enter</kbd> and <kbd>d</kbd> to equip and drop gear.</p>
      <p>Confirm target cursor and dialog actions with <kbd>Enter</kbd> and cancel with <kbd>q</kbd> or <kbd>Space</kbd>
    `;
  }

  render(stage) {
    return;
  }
}

export default HelpDialog;
